import { DateTime, Interval } from 'luxon'

export default {
  calculateDiference(inicio, fim) {
    let a = new Date(inicio)
    let b = new Date(fim)
    return Math.abs(a - b) // safe to use
  },
  msToTime(s) {
    var pad = (n, z = 2) => ('00' + n).slice(-z)
    return (
      pad((s / 3.6e6) | 0) +
      ':' +
      pad(((s % 3.6e6) / 6e4) | 0) +
      ':' +
      pad(((s % 6e4) / 1000) | 0)
    )
  },
  validDate(date) {
    return DateTime.fromFormat(date, 'dd/LL/yyyy').isValid
  },
  returnAge(date) {
    let dt = DateTime.fromSQL(date).isValid
      ? DateTime.fromSQL(date)
      : DateTime.fromFormat(date, 'dd/LL/yyyy')
    let now = DateTime.local()
    return Interval.fromDateTimes(dt, now)
      .toDuration('years')
      .toObject().years
  },

  parseDate(
    date,
    format = 'yyyy-LL-dd HH:mm:ss',
    formatReturn = 'dd/LL/yy HH:mm'
  ) {
    if (date) {
      let dt = DateTime.fromFormat(date, format)
      if (dt.isValid) {
        return dt.toFormat(formatReturn, { locale: 'br' })
      }
      let dt2 = DateTime.fromFormat(date, 'yyyy-LL-dd')
      if (dt2.isValid) {
        return dt2.toFormat(formatReturn, { locale: 'br' })
      }
      let dt3 = DateTime.fromFormat(date, 'yyyy-LL-dd HH:mm:ss')
      if (dt3.isValid) {
        return dt3.toFormat(formatReturn, { locale: 'br' })
      }
    }
    return false
  },
  isBefore(dateOne, dateTwo) {
    let dt1 = DateTime.fromSQL(dateOne).toMillis()
    let dt2 = DateTime.fromSQL(dateTwo).toMillis()
    //console.log('isBefore', dt1, dt2, dt1 < dt2)
    return dt1 < dt2
  },
  nextDay(date) {
    return DateTime.fromSQL(date)
      .plus({ days: 1 })
      .toFormat('yyyy-LL-dd', { locale: 'br' })
  },
  parseHourBeginToEnd(hour, duration) {
    let dt
    if (hour.length > 5) {
      dt = DateTime.fromFormat(hour, 'HH:mm:ss')
    } else dt = DateTime.fromFormat(hour, 'HH:mm')
    let end = dt.plus({ hours: parseInt(duration) })
    return dt.toFormat('HH:mm') + ' - ' + end.toFormat('HH:mm')
  },

  parseDateWithoutHour(date, format = 'yyyy-LL-dd', formatReturn = 'dd/LL/yy') {
    if (date) {
      let dt = DateTime.fromFormat(date, format)
      return dt.toFormat(formatReturn, { locale: 'br' })
    }
    return 'Erro ao converter data'
  },
  isPast(date) {
    let dt = DateTime.fromSQL(date)
    let now = DateTime.local()
    return dt < now
  },
  getDuration(date, format = 'yyyy-LL-dd HH:mm:ss') {
    if (date) {
      let dt = DateTime.fromFormat(date, format)
      let now = DateTime.local()
      return Interval.fromDateTimes(dt, now) //.length('milliseconds')
    }
  },
  getDurationBetween(later, from) {
    let dtLater = DateTime.fromSQL(later)
    let dtFrom = DateTime.fromSQL(from)
    return Interval.fromDateTimes(dtLater, dtFrom)
  },
  transformDateFormat(date, original, newFormat) {
    let dt = DateTime.fromFormat(date, original)
    if (dt) return dt.toFormat(newFormat)
    else return null
  },
  groupBy(list, keyGetter) {
    const map = new Map()
    list.forEach(item => {
      const key = keyGetter(item)
      const collection = map.get(key)
      if (!collection) {
        map.set(key, [item])
      } else {
        collection.push(item)
      }
    })
    return map
  },
  groupByTwo(arr, prop) {
    const map = new Map(Array.from(arr, obj => [obj[prop], []]))
    arr.forEach(obj => map.get(obj[prop]).push(obj))
    return Array.from(map.values())
  },
  removeAcento(text) {
    if (text) {
      text = text.toLowerCase()
      text = text.replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'a')
      text = text.replace(new RegExp('[ÉÈÊ]', 'gi'), 'e')
      text = text.replace(new RegExp('[ÍÌÎ]', 'gi'), 'i')
      text = text.replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'o')
      text = text.replace(new RegExp('[ÚÙÛ]', 'gi'), 'u')
      text = text.replace(new RegExp('[Ç]', 'gi'), 'c')
    }
    return text
  }
}
